import React from "react";
import { Link } from "@mui/material";

interface ClickableTextCellProps {
  text: string;
  onClick?: () => void;
}

export const ClickableTextCell: React.FC<ClickableTextCellProps> = ({
  text,
  onClick,
}) => {
  return (
    <Link
      component="button"
      variant="body2"
      onClick={onClick}
      sx={{
        fontWeight: 500,
        textAlign: "left",
        textTransform: "none",
        cursor: onClick ? "pointer" : "default",
        fontFamily: "Roboto, sans-serif",
      }}
    >
      {text}
    </Link>
  );
};